import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';

import { useAlertsStore } from '@tallo/design-system';

import { getPropertyAccessInstructionsQueryKey } from '../queries/access-instructions.query';
import accessInstructionsService from '../services/access-instructions.service';

export const useCreateAccessInstructions = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string; instructions: string; expiresAt?: string }) {
      return accessInstructionsService.create(payload.propertyId, {
        instructions: payload.instructions,
        expiresAt: payload.expiresAt,
      });
    },

    async onSuccess(_, payload) {
      await useQueryCache().invalidateQueries({ key: getPropertyAccessInstructionsQueryKey(payload.propertyId) });
    },

    onError() {
      useAlertsStore().error('Error creating access instructions');
    },
  });
});

export const useUpdateAccessInstructions = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string; instructionId: string; instructions: string; expiresAt?: string }) {
      return accessInstructionsService.update(payload.propertyId, payload.instructionId, {
        instructions: payload.instructions,
        expiresAt: payload.expiresAt,
        isValid: true,
      });
    },

    async onSuccess(_, payload) {
      await useQueryCache().invalidateQueries({ key: getPropertyAccessInstructionsQueryKey(payload.propertyId) });
    },

    onError() {
      useAlertsStore().error('Error updating access instructions');
    },
  });
});

export const useDeleteAccessInstructions = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string; instructionId: string }) {
      return accessInstructionsService.remove(payload.propertyId, payload.instructionId);
    },

    async onSuccess(_, payload) {
      await useQueryCache().invalidateQueries({ key: getPropertyAccessInstructionsQueryKey(payload.propertyId) });
      useAlertsStore().success('Access instructions deleted');
    },

    onError() {
      useAlertsStore().error('Error deleting access instructions');
    },
  });
});
